import { api } from '@/lib/api'
import type {
  FieldVerificationItem,
  FieldVerificationDetail,
  FieldVerificationListResponse,
  VerifyFieldRequest,
  RevokeVerificationRequest,
  SubjectType,
} from './types'

export const verificationApi = {
  verify: async (body: VerifyFieldRequest): Promise<FieldVerificationItem> => {
    const r = await api.post<FieldVerificationItem>('/api/field-verifications', body)
    return r.data
  },

  revoke: async (id: number, body: RevokeVerificationRequest): Promise<FieldVerificationItem> => {
    const r = await api.post<FieldVerificationItem>(
      `/api/field-verifications/${id}/revoke`, body,
    )
    return r.data
  },

  get: async (id: number): Promise<FieldVerificationDetail> => {
    const r = await api.get<FieldVerificationDetail>(`/api/field-verifications/${id}`)
    return r.data
  },

  listBySubject: async (
    subjectType: SubjectType, subjectId: number,
  ): Promise<FieldVerificationListResponse> => {
    const path = subjectType === 'contract'
      ? `/api/contracts/${subjectId}/field-verifications`
      : subjectType === 'customer'
      ? `/api/customers/${subjectId}/field-verifications`
      : `/api/annexes/${subjectId}/field-verifications`
    const r = await api.get<FieldVerificationListResponse>(path)
    return r.data
  },
}
